export function HeroCard() {
  return (
    <div className="mt-6 rounded-xl border border-border bg-card p-6 shadow-[var(--shadow-stack)] sm:p-8">
      <h1 className="font-[family-name:var(--font-heading)] text-3xl font-medium tracking-tight text-foreground sm:text-4xl">
        Reserve capacity
      </h1>
      <p className="mt-3 max-w-[620px] text-sm leading-relaxed text-muted-foreground sm:text-base">
        Tell us what you plan to send and how often, and we&apos;ll get you into the queue for production capacity.
        Capacity is first come, first served — submitting sets your place in line.
      </p>
    </div>
  );
}
